import {
  Box,
  Divider,
  Group,
  type MantineColor,
  Paper,
  Stack,
  Text,
} from '@mantine/core';
import { ChatCircleTextIcon } from '@phosphor-icons/react';

type WorkOrderMessage = {
  id: string;
  message: string;
  createdAt?: string | Date | null;

  fromUser: string | null;

  color?: MantineColor;
};

function formatDate(value?: string | Date | null) {
  if (!value) return 'No timestamp';

  return new Intl.DateTimeFormat('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}

export function MessagesList({ messages }: { messages: WorkOrderMessage[] }) {
  const sorted = [...messages].sort(
    (a, b) =>
      new Date(b.createdAt ?? 0).getTime() -
      new Date(a.createdAt ?? 0).getTime(),
  );

  return (
    <Paper withBorder radius="md" style={{ overflow: 'hidden' }}>
      {sorted.map((message, index) => {
        const author = message.fromUser ? message.fromUser : 'System';

        return (
          <Box key={message.id} pos="relative">
            {message.color && (
              <Box
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  bottom: 0,
                  width: 4,
                  backgroundColor: `var(--mantine-color-${message.color}-6)`,
                }}
              />
            )}
            <Stack gap={4} px="md" py="sm">
              <Group gap="xs">
                <ChatCircleTextIcon size={14} />

                <Text fw={600} size="sm">
                  {author}
                </Text>

                <Text c="dimmed" size="xs">
                  {formatDate(message.createdAt)}
                </Text>
              </Group>

              <Text size="sm" style={{ whiteSpace: 'pre-line' }}>
                {message.message}
              </Text>
            </Stack>
            {index < sorted.length - 1 && <Divider />}
          </Box>
        );
      })}
    </Paper>
  );
}
